

import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { initializeFilterData } from "../../EnvConfig/env_config";
import { setSubLoading } from "../../Redux/Services/AuthSlice";
import { NotificationSound } from "../CommonComponents/CommonNotification";
import { ApiCall, DropDownData, FindTranslatedKey, convertToNumber, convertTwoDecimalsOnValue, deleteData } from "../CommonComponents/CustomHooks";
import { handleDownloadExcel } from "../CommonComponents/ExportData";
import { FormButton, InputBox, SelectInputBox, Switch } from "../CommonComponents/InputBox";
import { Table } from "../CommonComponents/Table";

const VehicleModel = ({ menuText }) => {
    //--Inital State--//
    const dispatch = useDispatch();
    const inputrefs = useRef([]);
    const [loading, setLoading] = useState(false);
    const [sortConfig, setSortConfig] = useState({ SortColumn: null, SortOrder: null });
    const [currentPageNo, setCurrentPageNo] = useState(1);
    let [result, setResult] = useState([]);
    const [filterData, setFilterData] = useState(initializeFilterData)
    const ModelTypeData = DropDownData('GetModel');
    const FuelTypeData = DropDownData('GetFuelType');
    const [formData, setFormData] = useState({
        vehicleModelID: '',
        vehicleMakerTypeID: '',
        modelNumber: '',
        capacity: '',
        bodyLength: '',
        fuelType: '',
        seatingCapacity: '',
        fuelEfficiency:'',
        active: true
    })

    //--Handle Clear Function--//
    const handleClear = () => {
        setFormData({
            vehicleModelID: '',
            vehicleMakerTypeID: '',
            modelNumber: '',
            capacity: '',
            bodyLength: '',
            fuelType: '',
            seatingCapacity: '',
            fuelEfficiency: '',
            active: true
        });
        filterData.SearchText = ''
        getVehicleModelData()
        inputrefs.current['txtVehicleMakerTypeID'].focus();
    };

    //--handle Submit Function--//
    const handleSubmit = async () => {
        await dispatch(setSubLoading(true))
        let data = await ApiCall('/api/Master/InsertUpdateVehicleModel', formData)
        await dispatch(setSubLoading(false))
        if (data.status === 'ERROR' || data.status === 'EXPIRED' || data.status === 'UNAUTHORIZED' || data.status === 'SUCCESS') {
            await NotificationSound(data.status, data.message, data.focus, inputrefs, handleClear);
        }
    }

    //--handle Delete Function--//
    const handleDelete = async (ID) => {
        await dispatch(setSubLoading(true))
        await deleteData('/api/Master/DeleteVehicleModelMaster', { vehicleModelID: ID }, getVehicleModelData, handleClear, '', inputrefs)
        await dispatch(setSubLoading(false))
    }

    //--handle Sorting Function--//
    const handleSorting = (SortColumn) => {
        let SortOrder = 'ASC';

        if (sortConfig && sortConfig.SortColumn === SortColumn && sortConfig.SortOrder === 'ASC') {
            SortOrder = 'DESC';
        }
        setSortConfig({ SortColumn, SortOrder });
    };

    //--handle Edit Function--//
    const handleEdit = async (id) => {
        await dispatch(setSubLoading(true))
        let editData = await ApiCall('/api/Master/EditVehicleModelMaster', { vehicleModelID: id })
        await dispatch(setSubLoading(false))
        if (editData.status === 'UNAUTHORIZED' || editData.status === 'ERROR' || editData.status === 'EXPIRED') {
            await NotificationSound(editData.status, editData.message, editData.focus, inputrefs);
        }
        else {
            let record = editData.data
            setFormData((pre) => ({
                ...pre, ...record
            }))
        }

    }

    //--Grid Data Fetch Function--//
    const getVehicleModelData = async (CurrentPage) => {
        let PageIndex = 1
        if (CurrentPage !== undefined && typeof (CurrentPage) !== "object") {
            PageIndex = CurrentPage;
            setCurrentPageNo(CurrentPage);
        }
        else {
            setCurrentPageNo(1);
        }
        let GetData = {
            ...filterData,
            ...sortConfig,
            "PageIndex": PageIndex.toString(),
            "Type": "S",
        }
        setLoading(true)
        let data = await ApiCall('/api/Master/ShowVehicleModelMaster', GetData)
        setResult(data)
        setLoading(false)
        if (data.Status === 'EXPIRED') {
            await NotificationSound(data.Status, data.Message, data.focus, inputrefs);
        }
    }

    const handleChange1 = (event, value) => {
        getVehicleModelData(value);
    };



    useEffect(() => {
        getVehicleModelData();
    }, [sortConfig])

    useEffect(() => {
        inputrefs.current['txtVehicleMakerTypeID'].focus();
        document.title = 'Vehicle Model Master'
    }, [])

    return (
        <>
            <div className='main-card card border-0'>
                <div className='card-header mb-1'>
                    <h6 className="m-0"> {menuText ? menuText : FindTranslatedKey('Vehicle Model Master')}</h6>
                </div>

                <div className='card-body row'>

                    <div className='row'>

                        <SelectInputBox
                            label='Make'
                            inputrefs={inputrefs}
                            id='txtVehicleMakerTypeID'
                            required={true}
                            value={formData.vehicleMakerTypeID}
                            onChange={(e) => setFormData({ ...formData, vehicleMakerTypeID: e.target.value })}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') { inputrefs.current['txtModelNumber'].focus() };
                            }}

                        >
                            <option value=''>--Please Select--</option>
                            {ModelTypeData?.data?.dataList?.map((item, index) =>
                                <option key={`${item}${index}`} value={item.code}>{item.name}</option>
                            )}

                        </SelectInputBox>
                        <InputBox
                            label='Model Name'
                            inputrefs={inputrefs}
                            id='txtModelNumber'
                            maxLength='100'
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') { inputrefs.current['txtCapacity'].focus() };
                            }}
                            required={true}
                            value={formData.modelNumber}
                            onChange={(e) => setFormData({ ...formData, modelNumber: e.target.value })}
                        />
                        <InputBox
                            label='Capacity In Ton'
                            inputrefs={inputrefs}
                            id='txtCapacity'
                            maxLength='15'
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') { inputrefs.current['txtBodyLength'].focus() };
                            }}
                            required={true}
                            value={formData.capacity}
                            onChange={(e) => setFormData({ ...formData, capacity: convertTwoDecimalsOnValue(e.target.value) })}
                        />
                        <InputBox
                            label='Body Length (FT)'
                            inputrefs={inputrefs}
                            id='txtBodyLength'
                            maxLength='15'
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') { inputrefs.current['txtFuelType'].focus() };
                            }}
                            required={true}
                            value={formData.bodyLength}
                            onChange={(e) => setFormData({ ...formData, bodyLength: convertTwoDecimalsOnValue(e.target.value) })}
                        />

                      
                        <SelectInputBox
                            label='Fuel Type'
                            inputrefs={inputrefs}
                            id='txtFuelType'
                            value={formData.fuelType}
                            required={true}
                            onChange={(e) => setFormData({ ...formData, fuelType: e.target.value })}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') { inputrefs.current['txtSeatingCapacity'].focus() };
                            }}

                        >
                            <option value=''>--Please Select--</option>
                            {FuelTypeData?.data?.dataList?.map((item, index) =>
                                <option key={`${item}${index}`} value={item.code}>{item.name}</option>
                            )}
                        </SelectInputBox>
                        <InputBox
                            label='Seating Capacity'
                            inputrefs={inputrefs}
                            id='txtSeatingCapacity'
                            maxLength='2'
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') { inputrefs.current['txtFuelEfficiency'].focus() };
                            }}
                            required={true}
                            value={formData.seatingCapacity}
                            onChange={(e) => setFormData({ ...formData, seatingCapacity: convertToNumber(e.target.value) })}
                        />
                        <InputBox
                            label='Fuel Efficiency (km/l)'
                            PlaceHolderText='Fuel Efficiency (km/l)'
                            inputrefs={inputrefs}
                            id='txtFuelEfficiency'
                            value={formData.fuelEfficiency}
                            required={true}
                            maxLength='50'
                            onChange={(e) => {
                                setFormData({ ...formData, fuelEfficiency: convertTwoDecimalsOnValue(e.target.value) })
                            }}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    inputrefs.current['txtActive'].focus();
                                }
                            }}
                        />
                        <Switch
                            label='Active'
                            inputrefs={inputrefs}
                            id='txtActive'
                            checked={formData.active}
                            onChange={(e) => setFormData({ ...formData, active: e.target.checked })}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') { inputrefs.current['btnSave'].focus() };
                            }}
                        />

                    </div>

                    <div className='row pb-1 mt-2'>
                        <FormButton
                            id='btnSave'
                            inputrefs={inputrefs}
                            handleSubmit={handleSubmit}
                            handleExport={async () => {
                                await dispatch(setSubLoading(true))
                                await handleDownloadExcel('/api/Master/ShowVehicleModelMaster', filterData, 'Vehicle Model')
                                await dispatch(setSubLoading(false))
                            }}
                            handleClear={handleClear} />
                    </div>

                </div>

            </div>
            <Table handleEdit={handleEdit}
                handleDelete={handleDelete}
                PageName={'VehicleModel'}
                loading={loading}
                handleFilter={() => {
                    getVehicleModelData()
                    setFilterData({
                        ...filterData,
                    })
                }}
                filterData={filterData}
                tableData={result}
                setFilterData={setFilterData}
                currentPageNo={currentPageNo}
                handleChange1={handleChange1}
                handleSorting={handleSorting}
                sortConfig={sortConfig}
            />

        </>
    )
}

export default VehicleModel;